import { useEffect, useState } from 'react'
import { ProgressSpinner } from 'primereact/progressspinner'
import { useHistory, useLocation } from 'react-router-dom'

// local
import logo from './../assets/images/koc-logo.svg'
import EmployeeService from '../service/EmployeeService'
import http from '../core/http-common'

const Accepted = () => {
  const history = useHistory()
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const [token] = useState(params.has('token') ? params.get('token') : '')

  useEffect(() => {
    localStorage.setItem('token', token!.replaceAll(' ', '+'))
    const culture = localStorage.getItem('culture')
    if (!culture) localStorage.setItem('culture', 'tr-TR')

    getEmployeeSummery()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const goHome = () => history.push({ pathname: '/home', state: { from: 'accepted', evaluation: true } })

  const getEmployeeSummery = () => {
    EmployeeService.getEmployeeSummery(0)
      .then((employeeResponse) => {
        console.log('[Accepted] Employee response:', employeeResponse.data)
        localStorage.setItem('employee', JSON.stringify(employeeResponse.data))
        const employeeId = employeeResponse.data.id
        console.log('[Accepted] Employee ID:', employeeId)
        
        // Return employee ID to next then
        return employeeId
      })
      .then((employeeId) => {
        console.log('[Accepted] Fetching photo for employee ID:', employeeId)
        let photoUrl = EmployeeService.getEmployeePhotoBase64ById(employeeId)
        console.log('[Accepted] Photo URL:', photoUrl)
        return getEmployeePhoto(photoUrl)
      })
      .then((response) => {
        console.log('[Accepted] Photo response received')
        localStorage.setItem('employeePhoto', response.data)
        localStorage.setItem('kvkkDisplay', 'false')
        goHome()
      })
      .catch((e) => {
        console.error('[Accepted] Error:', e)
      })
  }

  const getEmployeePhoto = (url: string) => http.get<string>(url)

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        minHeight: '100vh',
      }}>
      <ProgressSpinner style={{ position: 'absolute', width: '120px' }} />
      <img style={{ position: 'absolute', width: '60px' }} src={logo} alt="app-logo-token" />
    </div>
  )
}

export default Accepted
